import { Box, Divider, Typography } from "@mui/material";

import DebtCard from "./DebtCard";
import DebtGrid from "./DebtGrid";

export default function DebtCategorySection({
  title,
  onCardClick,
  onDelete,
  debts = [],
  viewMode = "card",
  isLoading = false,
}) {
  if (!debts.length) return null;

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, mt: "2rem", fontWeight: "500 !important" }}>
        {title}
      </Typography>
      {viewMode === "card" ? (
        <Box className="cardContainer">
          {debts.map((debt) => (
            <DebtCard key={debt.id} debt={debt} onClick={() => onCardClick && onCardClick(debt)} onDelete={onDelete} />
          ))}
        </Box>
      ) : (
        <DebtGrid debts={debts} onDelete={onDelete} isLoading={isLoading} />
      )}

      <Divider className="debt-section-divider" />
    </Box>
  );
}
